import { createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnBadge"], {
        "static-id": $props.staticId,
        dot: false,
        size: "sm",
        class: _normalizeClass(["scale-[0.8] bg-en-red-100 text-en-red-400 border-en-red-400/30 pointer-events-none select-none", $props.inline ? 'ml-1 shrink-0' : 'absolute -top-4 -right-4 z-10'])
    }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" BETA ", -1 /* CACHED */)
            ]))]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["static-id", "class"]));
}
